import { NumericDateFormatPipe } from '../date-format/numeric-date-format.pipe';
import { EnvironmentService } from '../environment/environment.service';

import { DATEPICKER_ADAPTER, DatepickerAdapterService } from './datepicker-adapter.service';
import { DATEPICKER_PARSER_FORMATTER, DatepickerParserFormatterService } from './datepicker-parser-formatter.service';

export const DATEPICKER_FORMAT_PROVIDERS = [
  NumericDateFormatPipe,
  {
    provide: DATEPICKER_ADAPTER,
    useClass: DatepickerAdapterService,
    deps: [EnvironmentService, NumericDateFormatPipe]
  },
  {
    provide: DATEPICKER_PARSER_FORMATTER,
    useClass: DatepickerParserFormatterService,
    deps: [EnvironmentService, NumericDateFormatPipe]
  }
];
